export const getPartAdjustmentTypes = (state) => {
  return state.partAdjustmentTypes;
};
